import React, { useState, useRef, useEffect } from "react";
import AuthApi from "../../../service/AuthApi";
import userApi from "../../../service/userApi";
import { pushNotification } from "../../../utils/notifications";
import ReCAPTCHA from "react-google-recaptcha";
import { ModalXacNhanDiaChiIp } from "./ModalXacNhanDiaChiIp";
import { ModalXacThucDangNhap } from "./ModalXacThucDangNhap";
import { ModalXacThucBaoMat2Lop } from "./ModalXacThucBaoMat2Lop";
import { ModalThoaThuanSuDung } from "components/ThongBaoKhiDangNhap/ThongThuanSuDung";
import PrintFileApi from "service/PrintFileApi";

import { setToken, getToken, removeToken } from "utils/cookieExtension";
import { setTokenBase } from "service/common";

export const LoginForm = () => {
  const [formData, setFormData] = useState({
    AccountName: "",
    Password: "",
  });

  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const recaptchaRef = useRef(null);
  const [isShowModalXacNhanIp, setShowModalXacNhanIp] = useState(false);
  const [isShowModalXacNhan2Lop, setShowModalXacNhan2Lop] = useState(false);
  const setHideModalXacNhan2Lop = () => {
    setShowModalXacNhan2Lop(false);
  };
  const [showThoaThuanSuDung, setShowThoaThuanSuDung] = useState(false);
  const [redirectAfterAgree, setRedirectAfterAgree] = useState("");
  const [isPreLoginAgreement, setIsPreLoginAgreement] = useState(false);
  const [customerInfoFromUrl, setCustomerInfoFromUrl] = useState(null);
  const [preLoginAgreedEmail, setPreLoginAgreedEmail] = useState("");

  const handleAgreeThoaThuan = () => {
    if (isPreLoginAgreement) {
      // Lưu email để gọi API sau khi đăng nhập
      const email = customerInfoFromUrl?.email || "";
      setPreLoginAgreedEmail(email);
      setShowThoaThuanSuDung(false);
      setIsPreLoginAgreement(false);
    } else {
      setHideThoaThuanSuDung();
    }
  };

  const setHideThoaThuanSuDung = () => {
    setShowThoaThuanSuDung(false);
    window.location.href = redirectAfterAgree || "/trang-chu.aspx";
  };
  const [ipLogin, setIPLogin] = useState("");
  const setHideModalXacNhanIp = () => {
    setShowModalXacNhanIp(false);
    setTimeout(() => {
      window.location.href = "/trang-chu.aspx";
    }, 2000);
  };
  const [isShowModalXacThucDangNhap, setShowModalXacThucDangNhap] =
    useState(false);
  const setHideModalXacThucDangNhap = () => {
    setShowModalXacThucDangNhap(false);
  };
  useEffect(() => {
    removeToken("userInfo");
    removeToken("tokenMorman");
    document.title = "Đăng nhập | Phần mềm quản lý cầm đồ Morman";
    var showCaptcha = getToken("isShowCaptcha");
    if (showCaptcha == "1") {
      setIsShowCaptcha(true);
    }
    const params = new URLSearchParams(window.location.search);
    const name = params.get("name");
    const mail = params.get("mail");
    const sdt = params.get("sdt");
    const address = params.get("address");
    const emailParam = params.get("email");

    if (name || mail || sdt || address) {
      setCustomerInfoFromUrl({
        companyName: name || "",
        email: mail || "",
        phone: sdt || "",
        address: address || "",
      });
      setIsPreLoginAgreement(true);
      setShowThoaThuanSuDung(true);
    } else if (emailParam) {
      const fetchCustomerInfo = async () => {
        try {
          const response =
            await PrintFileApi.getThongTinKhachHangThoaThuan(emailParam);
          if (response && response.data) {
            if (
              response.data.NgayThoaThuan != undefined &&
              response.data.NgayThoaThuan != ""
            ) {
              setIsPreLoginAgreement(false);
              setShowThoaThuanSuDung(false);
            } else {
              const urlPart = response.data.url.split("?")[1] || "";
              if (urlPart !== "") {
                const urlParams = new URLSearchParams(urlPart);
                setCustomerInfoFromUrl({
                  companyName: urlParams.get("name") || "",
                  email: urlParams.get("mail") || "",
                  phone: urlParams.get("sdt") || "",
                  address: urlParams.get("address") || "",
                });
                setIsPreLoginAgreement(true);
                setShowThoaThuanSuDung(true);
              }
            }
          }
        } catch (err) {
          console.warn("Lỗi lấy thông tin khách hàng từ email:", err);
        }
      };
      fetchCustomerInfo();
    }
    const originalBodyClass = document.body.className;
    document.body.className =
      "vertical-layout vertical-menu 1-column blank-page page-blue";
    return () => {
      document.body.className = originalBodyClass;
    };
  }, []);
  const SetCookieShowCaptcha = (value) => {
    setToken("isShowCaptcha", value);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const SetThongTinLogin = (token) => {
    setToken("userInfo", "token=" + token);
    setToken("tokenMorman", token);
    setTokenBase(token, window.endPoint);
  };
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    if (errors.recaptcha) {
      setErrors((prev) => ({ ...prev, recaptcha: "" }));
    }
    if (errors.api) {
      setErrors((prev) => ({ ...prev, api: "" }));
    }
  };
  const validateForm = () => {
    let formIsValid = true;
    let newErrors = {};

    if (!formData.AccountName.trim()) {
      newErrors.AccountName = "Vui lòng nhập tên đăng nhập.";
      formIsValid = false;
    }
    if (!formData.Password) {
      newErrors.Password = "Vui lòng nhập mật khẩu.";
      formIsValid = false;
    } else if (formData.Password.length < 6) {
      newErrors.Password = "Mật khẩu ít nhất 6 ký tự";
      formIsValid = false;
    }
    if (!recaptchaToken && isShowCaptcha) {
      newErrors.recaptcha = "Vui lòng xác nhận bạn không phải robot.";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    if (!validateForm()) {
      const firstErrorField = Object.keys(errors).find((key) => errors[key]);
      if (firstErrorField) {
        const element = document.getElementsByName(firstErrorField)[0];
        element?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }
    setIsLoading(true);
    const apiData = {
      ...formData,
      RecaptchaToken:
        isShowCaptcha == true ? recaptchaToken : "isShowCaptcha=false",
    };
    try {
      const response = await AuthApi.login(apiData);
      if (response && response.status === 200) {
        SetCookieShowCaptcha("0");
        const choKichHoat = response.data.ChoKichHoat
          ? response.data.ChoKichHoat
          : 0;

        console.log("choKichHoat", choKichHoat);

        if (response.data.xacthuc == 1) {
          // tài khoản chủ hiện thông báo lưu địa chỉ ip
          setIPLogin(response.data.IP);
          setShowModalXacNhanIp(true);
          SetThongTinLogin(response.data.token);
        } else if (response.data.xacthuc == 2) {
          // Hiện ô nhập mã xác thực
          setShowModalXacThucDangNhap(true);
        } else if (response.data.baomat2lop == 1) {
          setToken("userInfo1", "username=" + response.data.username);
          setTimeout(() => {
            window.location.href = "two-factor";
          }, 2000);
        } else if (response.data.baomat2lop == 2) {
          setToken("userInfo1", "username=" + response.data.username);
          setShowModalXacNhan2Lop(true);
        } else if (response.data.linkNew == 1) {
          SetThongTinLogin(response.data.token);
          if (choKichHoat == "1") {
            setRedirectAfterAgree(response.data.RedirectUrl);
            setIsPreLoginAgreement(false);
            setShowThoaThuanSuDung(true);
          } else if (preLoginAgreedEmail) {
            // Người dùng đã đồng ý trước khi đăng nhập → gọi API ngay
            await userApi.capNhatTrangThaiThoaThuan(preLoginAgreedEmail);
            setToken("agreeTimeThoaThuanSuDung", new Date().toISOString());
            window.location.href =
              response.data.RedirectUrl || "/trang-chu.aspx";
          } else {
            setTimeout(() => {
              window.location.href = response.data.RedirectUrl;
            }, 2000);
          }
        } else {
          SetThongTinLogin(response.data.token);
          if (choKichHoat == "1") {
            setRedirectAfterAgree(response.data.RedirectUrl);
            setIsPreLoginAgreement(false);
            setShowThoaThuanSuDung(true);
          } else if (preLoginAgreedEmail) {
            // Người dùng đã đồng ý trước khi đăng nhập → gọi API ngay
            await userApi.capNhatTrangThaiThoaThuan(preLoginAgreedEmail);
            setToken("agreeTimeThoaThuanSuDung", new Date().toISOString());
            window.location.href =
              response.data.RedirectUrl || "/trang-chu.aspx";
          } else {
            setTimeout(() => {
              window.location.href = response.data.RedirectUrl;
            }, 2000);
          }
        }
      } else {
        const errorMessage =
          response?.data?.message ||
          response?.data ||
          "Đăng nhập thất bại. Vui lòng thử lại hoặc liên hệ hỗ trợ.";
        setErrors({ api: errorMessage });
        pushNotification(errorMessage, "error", "TOP_CENTER", 3000);
        if (recaptchaRef.current) recaptchaRef.current.reset();
        setRecaptchaToken(null);
        setIsShowCaptcha(true);
        SetCookieShowCaptcha("1");
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        "Đã xảy ra lỗi hệ thống. Vui lòng thử lại.";
      setErrors({ api: errorMessage });
      pushNotification(errorMessage, "error", "TOP_CENTER", 3000);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setRecaptchaToken(null);
      SetCookieShowCaptcha("1");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="content">
        <div className="sign-main content-wrapper">
          <div className="content-header row mb-4"></div>
          <div className="content-body">
            <section className="flexbox-container form-login">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <div className="col-md-3 col-10 box-shadow-2 p-0">
                  <div className="card border-grey border-lighten-3 m-0">
                    <div className="card-header border-0">
                      <a href="http://morman.vn/">
                        <div className="card-title text-center">
                          <div className="p-1">
                            <img
                              src="/app-assets/images/logo/logo-dark.png"
                              alt="logo"
                            />
                          </div>
                        </div>
                        <h5 className="card-subtitle1 text-center">
                          <span>PHẦN MỀM QUẢN LÝ CẦM ĐỒ SỐ 1 VIỆT NAM</span>
                        </h5>
                        <h6 className="card-subtitle line-on-side text-muted text-center mb-1 pt-2">
                          <span>Đăng nhập với MorMan</span>
                        </h6>
                      </a>
                    </div>
                    <div className="card-content">
                      <div className="card-body">
                        <form
                          onSubmit={handleSubmit}
                          noValidate
                          className="form-horizontal form-simple"
                        >
                          <fieldset className="form-group position-relative has-icon-left mb-1">
                            <input
                              name="AccountName"
                              type="text"
                              value={formData.AccountName}
                              onChange={handleInputChange}
                              className={`form-control ${
                                errors.AccountName ? "is-invalid" : ""
                              }`}
                              placeholder="Email hoặc tài khoản đăng nhập"
                              required
                            />
                            <div className="form-control-position">
                              <i className="ft-user"></i>
                            </div>
                            <div className="invalid-feedback red text-left">
                              {errors.AccountName}
                            </div>
                          </fieldset>
                          <fieldset className="form-group position-relative has-icon-left mb-1">
                            <input
                              name="Password"
                              type="password"
                              value={formData.Password}
                              onChange={handleInputChange}
                              className={`form-control ${
                                errors.Password ? "is-invalid" : ""
                              }`}
                              placeholder="Mật khẩu"
                              required
                            />
                            <div className="form-control-position">
                              <i className="la la-key"></i>
                            </div>
                            <div className="invalid-feedback red text-left">
                              {errors.Password}
                            </div>
                          </fieldset>
                          <p className="text-right text-muted">
                            <a
                              href="/quen-mat-khau.aspx"
                              className="card-link blue"
                            >
                              Quên mật khẩu?
                            </a>
                          </p>
                          {isShowCaptcha && (
                            <div className="d-flex justify-content-center my-1">
                              <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey="6LclF-ggAAAAAPseVHjTInekDYaYruu3YFJ24y_P"
                                onChange={handleRecaptchaChange}
                                onExpired={() => {
                                  setRecaptchaToken(null);
                                  setErrors((prev) => ({
                                    ...prev,
                                    recaptcha: "Mã CAPTCHA đã hết hạn.",
                                  }));
                                }}
                              />
                            </div>
                          )}
                          <button
                            type="submit"
                            className="btn btn-info btn-lg btn-block"
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              <i className="ft-unlock"></i>
                            )}
                            {isLoading ? " Đang xử lý..." : " Đăng nhập"}
                          </button>
                        </form>
                      </div>
                    </div>
                    <p className="text-center text-muted">
                      Bạn là khách hàng mới?{" "}
                      <a
                        href="/dang-ky-dung-thu.aspx"
                        className="card-link blue"
                      >
                        Đăng ký
                      </a>
                    </p>
                  </div>
                </div>
                {isShowModalXacNhanIp == true && (
                  <ModalXacNhanDiaChiIp
                    onHide={setHideModalXacNhanIp}
                    show={isShowModalXacNhanIp}
                    ipLogin={ipLogin}
                  />
                )}
                {isShowModalXacThucDangNhap == true && (
                  <ModalXacThucDangNhap
                    onHide={setHideModalXacThucDangNhap}
                    show={isShowModalXacThucDangNhap}
                    data={formData}
                  />
                )}
                {isShowModalXacNhan2Lop == true && (
                  <ModalXacThucBaoMat2Lop
                    onHide={setHideModalXacNhan2Lop}
                    show={isShowModalXacNhan2Lop}
                    data={formData}
                  />
                )}
                {/* {showThoaThuanSuDung && (
                  <ModalThoaThuanSuDung
                    show={showThoaThuanSuDung}
                    onHide={setHideThoaThuanSuDung}
                    onAgree={setHideThoaThuanSuDung}
                  />
                )} */}
              </div>
            </section>
          </div>
        </div>
      </div>
      {showThoaThuanSuDung && (
        <ModalThoaThuanSuDung
          dialogClassName="modal-xl"
          show={showThoaThuanSuDung}
          onAgree={handleAgreeThoaThuan}
          customerInfoInit={customerInfoFromUrl}
        />
      )}
    </>
  );
};
